module.exports = __webpack_public_path__ + "img/bv.4004c9d0.svg";